import React from 'react';

import {
  borderRadius,
  Col,
  Cols,
  ISimpleOptionSelect,
  spacingV2,
  Text,
} from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface IGarmScoreOptionSelect extends ISimpleOptionSelect {
  description: string;
}

interface IGarmScoreSelectorProps {
  options: IGarmScoreOptionSelect[];
  onChange: (id: string) => void;
}

export const GarmScoreSelector = ({
  options,
  onChange,
}: IGarmScoreSelectorProps): React.ReactElement => {
  return (
    <Cols gap='1rem' wrap>
      {options.map((option) => {
        return (
          <Col
            extraSmallVerticalPadding
            horizontalPadding
            onClick={() => {
              onChange(option.value);
            }}
            style={{
              marginTop: spacingV2.extraSmall, // for spacing once this wraps
              border: option.isSelected ? `1px solid ${publicaColors.black}` : 'none',
              borderRadius: borderRadius.base,
              //   backgroundColor: option.isSelected ? publicaColors.lighterBlue : 'inherit',
              backgroundColor: option.backgroundColor,
              cursor: 'pointer',
            }}
          >
            <Text disableSelect small bold={option.isSelected} color={option.color}>
              {option.value}
            </Text>
          </Col>
        );
      })}
    </Cols>
  );
};
